import dataStore from '../../data/data';
import { useEffect, useRef, useState } from 'react';
import { TransformControls } from '@react-three/drei';

export default function Facemesh({object,position = [0, 0, 0],}) {
  const dragging = dataStore(_data => _data.editor.controls.dragging);
  const meshRef = useRef();
  const setData=dataStore.setState;
  const [hovered, setHovered] = useState(false);
  const [mode, setMode] = useState('rotate');
  
  useEffect(() => {
    const modes=['rotate','scale','translate'];
    const down = (e) => {
      if (e.key !== 'z' || e.repeat) return;

      setMode(prev => {
        const idx = modes.indexOf(prev);
        const next = modes[(idx + 1) % modes.length];
        return next;
      });
    };

    window.addEventListener('keydown', down);
    return () => window.removeEventListener('keydown', down);
  }, []);

  if (!object) return null;

  return (
    <>
      <primitive
        ref={meshRef}
        object={object}
        position={position}
        onPointerOver={(e) => {
          e.stopPropagation();
          setHovered(true);
          document.body.style.cursor = 'grab';
        }}
        onPointerOut={(e) => {
          e.stopPropagation();

          if (!dragging) {
            setHovered(false);
          }

          document.body.style.cursor = 'default';
        }}
      />

      {(hovered || dragging) && (
        <TransformControls
          enabled={hovered||dragging}
          mode={mode}
          object={meshRef.current}
          onMouseDown={() => setData((_data)=>({
            ..._data,
            editor:{
              ..._data.editor,
              controls:{
                ..._data.editor.controls,
                dragging:true
              }
            }
          }))}
          onMouseUp={() => {
            setData((_data)=>({
              ..._data,
              editor:{
                ..._data.editor,
                controls:{
                  ..._data.editor.controls,
                  dragging:false
                }
              }
            }));
            setHovered(false);
          }}
        />
      )}
    </>
  );
}